import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import AddUpdateUI from "./AddUpdateUI.jsx";
import { getStates } from "../../../services/CommonServices";

const AddUpdateCity = ({ formik, relationData }) => {
  const dispatch = useDispatch();
  const [selectedState, setSelectedState] = useState({});

  useEffect(() => {
    dispatch(getStates());
    if (relationData && Object.keys(relationData).length > 0) {
      setSelectedState({
        label: relationData.state.name,
        value: relationData.state._id,
      });
    }
  }, [relationData]);

  return (
    <AddUpdateUI
      selectedState={selectedState}
      setSelectedState={setSelectedState}
      formik={formik}
    />
  );
};

export default AddUpdateCity;
